export const collectifs = [
  { id: 1, nom: "Éco-Quartier Luc-sur-Mer", lat: 49.317, lng: -0.348, participants: 4, production_kWp: 6, production: '5834 kWh' },
  { id: 2, nom: "Greenwest Montigny", lat: 48.775, lng: 2.044, participants: 7, production_kWp: 10, production: '9850 kWh' },
  { id: 3, nom: "Collectif Solaire Versailles", lat: 48.800, lng: 2.142, participants: 6, production_kWp: 7, production: '7230 kWh' },
  { id: 4, nom: "Énergie Partagée Nozay", lat: 48.660, lng: 2.234, participants: 5, production_kWp: 5.8, production: '8345 kWh' }
];
